<template>
  <div class="accordion">
    <div class="accordion__question">
      <button
        :aria-expanded="isOpen ? 'true' : 'false'"
        :data-tab-order="tabOrder"
        :class="[{ expanded: isOpen }, { collapsed: !isOpen }]"
        @click="handleQuestionClick"
        class="accordion__question__btn"
      >
        <slot name="question"></slot>
        <div class="accordion__question__btn__icon">
          <div class="accordion__question__btn__icon__line-1"></div>
          <div class="accordion__question__btn__icon__line-2"></div>
        </div>
      </button>
    </div>
    <div class="accordion__answer" v-if="isOpen">
      <slot name="answer"></slot>
    </div>
  </div>
</template>

<script>
/* global gtag */
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  props: ['tabOrder'],
  methods: {
    handleQuestionClick(evt) {
      this.isOpen = !this.isOpen;
      // only fire once
      if (this.isOpen) {
        gtag('event', 'troubleShootClick', {
          event_label: evt.currentTarget.children[0].innerHTML.toLowerCase(),
          event_category: 'troubleshoot',
          value: 1,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  padding: 16px 0;
  border-bottom: 1px solid $grey;

  &__question__btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: transparent;
    font-weight: 600;
    color: $dark-grey;
    text-align: left;
    padding: 0;
    border: none;

    &__icon {
      position: relative;
      margin-left: 17px;
      min-height: 26px;
      height: 26px;
      min-width: 26px;
      width: 26px;
      background-color: $azure;
      border-radius: 12.5px;

      &__line-1,
      &__line-2 {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(0);
        position: absolute;
        background-color: white;
        height: 16px;
        width: 2px;
        border-radius: 2.5px;
      }

      &__line-2 {
        transform: translate(-50%, -50%) rotate(90deg);
        background-color: white;
      }
    }

    &.expanded {
      .accordion__question__btn__icon__line-1 {
        transform: translate(-50%, -50%) rotate(90deg);
      }
    }
  }

  &__answer {
    margin-top: 12px;

    ul {
      margin: 0;
      padding-left: 20px;
    }
  }

  @include desktop {
    margin-right: 15px;

    &__question__btn {
      justify-content: normal;
      flex-direction: row-reverse;
      width: auto;

      &__icon {
        margin-left: 0;
        margin-right: 16px;
      }
    }

    &__answer {
      margin: 12px 0 0 42px;
    }
  }
}
</style>
